module.exports = __webpack_public_path__ + "img/Vizuro Logo - PNG.ae6f3adf.webp";